import { Type } from '@sinclair/typebox';
import { NullishType, YearMonthDayStringType } from '../../standard-schema.js';
import { OrganisationWithStakeholdersSchemaWithoutPID, SelectProjectOrganisationSchema, } from './organisation/index.js';
export var CompensationForm;
(function (CompensationForm) {
    CompensationForm["FAST"] = "Fast";
    CompensationForm["LOPANDE"] = "L\u00F6pande";
    CompensationForm["INCITAMENT"] = "Incitament";
    CompensationForm["TAKPRIS"] = "Takpris";
    CompensationForm["ANNAT"] = "Annat";
})(CompensationForm || (CompensationForm = {}));
export var ContractorType;
(function (ContractorType) {
    ContractorType["TOTAL"] = "total";
    ContractorType["EXECUTION"] = "execution";
})(ContractorType || (ContractorType = {}));
export var ProjectType;
(function (ProjectType) {
    ProjectType["HGA"] = "HGA";
    ProjectType["ROT"] = "ROT";
    ProjectType["SERVICE"] = "Service";
})(ProjectType || (ProjectType = {}));
const BaseProjectSchema = Type.Object({
    id: Type.String(),
    fortnoxId: Type.String(),
    name: Type.String(),
    status: NullishType(Type.String()),
    size: NullishType(Type.Number()),
    contractSum: NullishType(Type.Number()),
    arvode: NullishType(Type.Number({ minimum: 0 })),
    startDate: NullishType(Type.String()),
    endDate: NullishType(Type.String()),
    notes: NullishType(Type.String()),
});
const StrictProjectTypes = Type.Object({
    type: NullishType(Type.Enum(ProjectType)),
    compensationForm: NullishType(Type.Enum(CompensationForm)),
    contractorType: NullishType(Type.Enum(ContractorType)),
    samprovDate: NullishType(YearMonthDayStringType),
    douinDate: NullishType(YearMonthDayStringType),
    handoverDate: NullishType(YearMonthDayStringType),
    fdobDate: NullishType(YearMonthDayStringType),
});
const LaxProjectTypes = Type.Object({
    type: NullishType(Type.String()),
    compensationForm: NullishType(Type.String()),
    contractorType: NullishType(Type.String()),
    samprovDate: NullishType(Type.String()),
    douinDate: NullishType(Type.String()),
    handoverDate: NullishType(Type.String()),
    fdobDate: NullishType(Type.String()),
});
export const InsertProjectSchema = Type.Intersect([
    Type.Omit(BaseProjectSchema, ['id']),
    StrictProjectTypes,
]);
export const SelectProjectSchema = Type.Intersect([BaseProjectSchema, LaxProjectTypes]);
export const UpdateProjectSchema = Type.Partial(Type.Intersect([Type.Omit(BaseProjectSchema, ['contractSum']), StrictProjectTypes]));
export const ProjectSchema = BaseProjectSchema;
const ProjectOrganisationWithoutPID = Type.Omit(SelectProjectOrganisationSchema, ['projectId']);
// --- JOIN ---
export const ProjectWithOrganisationSchema = Type.Intersect([
    BaseProjectSchema,
    Type.Object({
        organisation: ProjectOrganisationWithoutPID,
    }),
]);
// --- JOIN ---
export const ProjectWithOrganisationWithStakeholdersSchema = Type.Intersect([
    BaseProjectSchema,
    Type.Object({
        organisation: OrganisationWithStakeholdersSchemaWithoutPID,
    }),
]);
